<template>
  <div v-if="response && response.numFound">
    <b-form-checkbox v-model="preserve"
    @change="onChange" class="mb-3">
      <em>Preserve filters for next search</em>
    </b-form-checkbox>
  </div>
</template>

<script>
export default {
  name: 'PreserveFilters',
  data () {
    return {
      preserve: '',
    }
  },
  created: function () {
    this.preserve = this.preserveFilters;
  },
  computed: {
    preserveFilters () {
      if (this.$store.state.preserveFilters ) {
        return this.$store.state.preserveFilters;
      } else {
        return '';
      }
    },
    response () {
      return (this.$store.state.response)
        ? this.$store.state.response.response : null;
    }
  },
  watch: {
    preserveFilters: function (newPF) {
      this.preserve = newPF;
    }
  },
  methods: {
    onChange: function(e) {
      return this.$store.commit('setPreserveFilters', e)
    }
  }

}
</script>

<style scoped>

</style>
